import React, {useState} from "react";
import {Row} from "antd";
import moment from "moment";
import {useFetch} from "../../hooks/useFetch";
import stores from "../../store/stores";
import ShiftManagementFilters from "../shiftManagement/Components/ShiftManagementFilters";
import {CustomButton} from "../_defaultComponents/CustomButton/CustomButton";
import {DownloadOutlined} from "@ant-design/icons";
import {t} from "i18next";
import ShiftTable from "../shiftManagement/Components/ShiftTable";

const ShiftManagementSnapshot = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [reloadData, setReloadData] = useState({});
    const [filters, setFilters] = useState({
        city: "all",
        company: undefined,
        subcompany: undefined,
        period: "choose",
        startDate: moment()
            .subtract(1, "d")
            .toDate(),
        endDate: moment().toDate(),
        searchText: undefined
    });

    const [loading, data, setData, setLoading] = useFetch({
        fetchFn: stores.shiftStore.getSnapshotList.bind(null, {
            limit: 10,
            skip: (currentPage - 1) * 10,
            city: filters.city,
            company: filters.company,
            subcompany: filters.subcompany,
            period: filters.period,
            startDate: filters.startDate,
            endDate: filters.endDate,
            searchText: filters.searchText
        }),
        dependencies: [filters, currentPage, reloadData]
    });

    return (
        <div>
            <Row gutter={[8, 8]}>
                <ShiftManagementFilters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                    isSnapshot={true}
                    workType={undefined}
                    setWorkType={() => {}}
                />
            </Row>
            <Row>
                <CustomButton
                    type="primary"
                    data-testid="exportWithExcelButton"
                    onClick={async () => {
                        const data = {
                            skip: (currentPage - 1) * 10,
                            limit: 10,
                            city: filters.city,
                            company: filters.company,
                            subcompany: filters.subcompany,
                            period: filters.period,
                            startDate: filters.startDate,
                            endDate: filters.endDate,
                            searchText: filters.searchText
                        };
                        const response = await stores.shiftStore.downloadShiftExcelFileSnapshot(
                            data
                        );
                        let link = document.createElement("a");
                        link.href = response;
                        link.download = `${t("screens.shiftManagement", {ns: "common"})}.xlsx`;
                        document.body.appendChild(link);
                        link.click();
                        setTimeout(function() {
                            window.URL.revokeObjectURL(link);
                        }, 200);
                    }}
                    icon={<DownloadOutlined />}
                >
                    {t("companyDetail.actions.exportWithExcel", {
                        ns: "companyDetail"
                    })}
                </CustomButton>
            </Row>
            <Row style={{marginTop: 16}}>
                <ShiftTable
                    loading={loading}
                    data={data?.rows || []}
                    dataCount={data?.dataCount}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    setReloadData={() => setReloadData(!reloadData)}
                />
            </Row>
        </div>
    );
};

export default ShiftManagementSnapshot;
